import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiLinearProgress = {
  styleOverrides: { root: { borderRadius: '8px', overflow: 'hidden' } },
} satisfies Components<Theme>['MuiLinearProgress'];
